import type { MutableRefObject } from 'react';
import { useCallback } from 'react';
import { useStoreActions } from '@/store';

export const useCheckoutAsGuest = (
  formRef: MutableRefObject<HTMLFormElement>,
): (() => void) => {
  const { setIsMemberBenefitsInterstitialOpen, setCheckForMemberBenefits } =
    useStoreActions(store => store.ui);

  return useCallback(() => {
    setIsMemberBenefitsInterstitialOpen(false);
    setCheckForMemberBenefits(false);

    // Submit the form, so we can run our normal handlers
    formRef.current.dispatchEvent(
      new Event('submit', { bubbles: true, cancelable: true }),
    );
  }, [formRef]);
};
